import { Help, South } from '@mui/icons-material'
import { Box, Button, Fade } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { PslToolTip } from '../../../../../core/global/ToolTip'
import { useHistory } from 'react-router-dom'

export const UsageAverage = () => {
    const [showTooltip, setShowTooltip] = useState(true)

    const history = useHistory();

    useEffect(() => {
        setTimeout(() => {
            setShowTooltip(false)
        }, 5500);
        // eslint-disable-next-line
    }, [])

    return (
        <Box display="flex" justifyContent="space-between" alignItems="center" width="100%" borderRadius="12px" p="12px" border="1px solid #D6D9DB">
            <Box display="flex" flexDirection="column" gap="8px">
                <Box display="flex" alignItems="center" gap="8px">
                    <Box fontSize="12px" fontWeight="800" color="#292C2F">Usage Average</Box>
                    <Help sx={{fontSize: '16px', color: '#292C2F'}} />
                </Box>
                <Box display="flex" alignItems="center" gap="16px">
                    <Box fontSize="20px" fontWeight="800" color="#292C2F">90%</Box>
                    <Box p="4px 12px" borderRadius="100px" color="#fff" bgcolor="#C99E00" fontSize="12px" >Heroic</Box>
                </Box>
                <Box display="flex" alignItems="center">
                    <South sx={{color: '#C99E00', fontSize: '12px'}}/>
                    <Box fontSize="12px" color="#C99E00">12% Last 7 days</Box>
                </Box>
            </Box>
            <PslToolTip
                open={showTooltip}
                title="Explore the Usage Awareness page to see how effectively you are using the app. To see details, click 'See Usage Stats'"
                arrow
                placement='bottom-start'
                slots={{ transition: Fade }}
                slotProps={{
                    transition: { timeout: 1000 },
                }}
            >
                <Button onClick={() => history.push('/psl/profile?tab=usage-awareness')} variant='contained' disableElevation sx={{background: '#F7F8F8', color: '#292C2F', fontSize: '12px', '&:hover':{background: '#F7F8F8'}}}>
                    See Usage Stats
                </Button>
            </PslToolTip>
        </Box>
    )
}
